import React from 'react'
import { useIntl } from 'react-intl'
import { Box } from '@mui/material'
import { Level, LEVELS, LEVEL_COLORS } from '../ratingLevel'
import { ui } from '../../../../utils/uiTokens'

interface Props {
    counts: Record<Level, number>
    total: number
    // в Шолу басшы под кольцом число учеников не пишем
    hideCount?: boolean
}

const R = 30
const C = 2 * Math.PI * R

const LevelCards: React.FC<Props> = ({ counts, total, hideCount = false }) => {
    const { formatMessage } = useIntl()

    return (
        <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
            {LEVELS.map((level) => {
                const c = LEVEL_COLORS[level]
                const pct = total ? Math.round((counts[level] * 100) / total) : 0
                return (
                    <Box
                        key={level}
                        sx={{
                            width: 128,
                            py: 1.5,
                            borderRadius: '14px',
                            border: `1px solid ${c.border}`,
                            background: c.bg,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: 1,
                        }}
                    >
                        <Box sx={{ position: 'relative', width: 76, height: 76 }}>
                            <svg width="76" height="76" viewBox="0 0 76 76">
                                <circle cx="38" cy="38" r={R} fill="none" stroke={ui.card} strokeWidth="8" />
                                <circle
                                    cx="38"
                                    cy="38"
                                    r={R}
                                    fill="none"
                                    stroke={c.accent}
                                    strokeWidth="8"
                                    strokeLinecap={pct ? 'round' : 'butt'}
                                    strokeDasharray={`${(C * pct) / 100} ${C}`}
                                    transform="rotate(-90 38 38)"
                                />
                            </svg>
                            <Box
                                sx={{
                                    position: 'absolute',
                                    inset: 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '17px',
                                    fontWeight: 700,
                                    color: c.text,
                                }}
                            >
                                {pct}%
                            </Box>
                        </Box>
                        {!hideCount && (
                            <Box sx={{ fontSize: '13px', fontWeight: 600, color: c.text }}>
                                {formatMessage({ id: 'studentsCount' }, { count: counts[level] })}
                            </Box>
                        )}
                    </Box>
                )
            })}
        </Box>
    )
}

export default LevelCards
